export default __webpack_public_path__ + "static/media/g2-crowd-rating.f0584539.png";